import { LogLevel } from '../enums/Enum';
import ServerLog from './ServerLog';
import GlobalVariables from '../GlobalVariables';


const getScript = (url, callback, debug) => {
    let script = document.createElement('script');
    const head = document.head || document.getElementsByTagName('head')[0] || document.documentElement;

    script.src = url;
    if (debug === true) {
        script.src += '&debug=true';
    }

    script.id = `apexchat_script_${++GlobalVariables.scriptId}`;

    // add a monitor
    const timeout = window.setTimeout(() => {
        if (!script.loaded) {
            ServerLog.log({
                level: LogLevel.Error,
                visitorId: 0,
                companyId: 0,
                text: 'Timeout hit'
            });
            alert("We're sorry, but the chat could not be started. Please try again.");
        }
    }, 30000);

    // when the script loads, clear the timeout and invoke the callback
    script.onload = script.onreadystatechange = function (_, isAbort) {
        if (!script.readyState || /loaded|complete/.test(script.readyState)) {
            window.clearTimeout(timeout);
            try {
                // Callback if not abort
                if (!isAbort) {
                    callback();
                }

                // Handle memory leak in IE
                script.onload = script.onreadystatechange = null;

                // Remove the script
                if (head && script.parentNode) {
                    head.removeChild(script);
                }

                // Dereference the script
                script = undefined;
            } catch (e) {
            }
        }
    };

    // Use insertBefore instead of appendChild  to circumvent an IE6 bug.
    // This arises when a base node is used, per Jquery bugs (#2709 and #4378).
    head.insertBefore(script, head.firstChild);
};
export default getScript;
